import * as React from 'react';
import { ticketStatusLabel, ticketStatusTone, type TicketStatusTone } from '@/shared/config';
import { cn } from '@/shared/lib/cn';
import styles from './StatusBadge.module.css';

const TONE_CLASS: Record<TicketStatusTone, string> = {
  neutral: styles.toneNeutral,
  pending: styles.tonePending,
  info: styles.toneInfo,
  accent: styles.toneAccent,
  review: styles.toneReview,
  warning: styles.toneWarning,
  positive: styles.tonePositive,
  danger: styles.toneDanger,
};

export interface StatusBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  status: string;
  label?: string | null;
  dot?: boolean;
  size?: 'sm' | 'md';
}

/**
 * Бейдж статуса заявки. Цвет считается из статуса (ticketStatusTone), а не
 * задаётся местом вызова — чтобы список, шапка и портал не расходились.
 *
 * @use статус заявки из флоу — знает про цвета статусов, в отличие от Badge.
 */
export function StatusBadge({
  status,
  label,
  dot = false,
  size = 'md',
  className,
  ...rest
}: StatusBadgeProps) {
  return (
    <span
      className={cn(
        styles.badge,
        TONE_CLASS[ticketStatusTone(status)],
        size === 'sm' && styles.sm,
        dot && styles.dot,
        className,
      )}
      {...rest}
    >
      {ticketStatusLabel(status, label)}
    </span>
  );
}
